export enum SearchFilterEnum {
  All = "All",
  Officers = "Officer",
  Common = "Common",
  SpecialProject = "SpecialProject"
}



// WEBPACK FOOTER //
// ./src/components/Refatoracao/TradeList/SearchFilterEnum.ts